import script from "./Folder.vue?vue&type=script&setup=true&lang=js"
export * from "./Folder.vue?vue&type=script&setup=true&lang=js"

import "./Folder.vue?vue&type=style&index=0&id=0116090b&lang=css"
import "./Folder.vue?vue&type=style&index=1&id=0116090b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0116090b"]])

export default __exports__